// extracted by css-extract-rspack-plugin
export default {"cls1":"session_trail-cls1_YLF","cls2":"session_trail-cls2_ac9 session_trail-cls1_YLF"};